import { useCallback, useEffect, useState } from 'react'
import { getTreeDetails } from '@fs/zion-tree-groups'

/**
 * Fetches tree details and exposes refetch function; exposes error for potential future handling
 * @param {import('@fs/zion-tree-types').TreeId | undefined} treeId
 * @returns {{treeDetails: import('@fs/zion-tree-types').TreeDetails | undefined, error: Error | undefined, refetchTreeDetails: () => void}}
 */

export function useTreeDetails(treeId) {
  const [treeDetails, setTreeDetails] = useState()
  const [error, setError] = useState()
  const [refetchTrigger, setRefetchTrigger] = useState(0)

  const refetchTreeDetails = useCallback(() => {
    setRefetchTrigger((prev) => prev + 1)
  }, [])

  useEffect(() => {
    let isCurrent = true
    async function fetchDetails() {
      try {
        const data = await getTreeDetails(treeId)
        if (isCurrent) setTreeDetails(data)
      } catch (err) {
        if (isCurrent) setError(err)
      }
    }
    if (treeId) {
      fetchDetails()
    }
    return () => {
      isCurrent = false
    }
  }, [treeId, refetchTrigger])

  return { treeDetails, error, refetchTreeDetails }
}
